import { render, staticRenderFns } from "./ContactTouch.vue?vue&type=template&id=ef3e3cf0&scoped=true&"
import script from "./ContactTouch.vue?vue&type=script&lang=js&"
export * from "./ContactTouch.vue?vue&type=script&lang=js&"
import style0 from "./ContactTouch.vue?vue&type=style&index=0&id=ef3e3cf0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef3e3cf0",
  null
  
)

export default component.exports